// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=checkbox]:checked.dark[data-v-056edd72]{--bg-opacity:1;background-color:#0b1426;background-color:rgba(11,20,38,var(--bg-opacity))}button[disabled][data-v-056edd72]:not(.form-btn),input[disabled][data-v-056edd72],input[disabled]+label[data-v-056edd72]{color:#d3d3d3;cursor:not-allowed}button[disabled][data-v-056edd72]:not(.form-btn){background:none;border-color:#d3d3d3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
